export const izjava_povj_voditelj= {
  templateId: 90,
  category: 9,
  templateTitle: "Izjava o povjerljivosti osoba zaduženih od voditelja obrade",
  templateDescription: `Voditelj obrade dužan je osigurati povjerljivost pri obradi podataka i u slučaju da za njega poslove obrade obavljaju radnici ili bilo koje treće osobe, a obveza voditelja obrade je da navedeno dokaže po potrebi.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Voditelj obrade je dužan osobne podatke obrađivati na način kojim se osigurava odgovarajuća sigurnost osobnih podataka, uključujući zaštitu od neovlaštene ili nezakonite obrade te od slučajnog gubitka, uništenja ili oštećenja primjenom odgovarajućih tehničkih ili organizacijskih mjera.</p>
    <p>Voditelj obrade i izvršitelj obrade provode odgovarajuće tehničke i organizacijske mjere kako bi osigurali odgovarajuću razinu sigurnosti s obzirom na rizik, uključujući prema potrebi sposobnost osiguravanja trajne povjerljivosti.</p>

     <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
  `,
  
  sides: [
  {
    prefix: "Na temelju Opće uredbe o zaštiti podataka,",
    signature: "Osoba zadužena od voditelja:",
  	inputs:[{ 
      type: "input", 
      required: true, 
      placeholder: "Ime i prezime",
      label: "Ime i prezime",
      inSignature: true,
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "Adresa i mjesto rada",
    },
    { 
      type: "input", 
      required: false, 
      placeholder: "Broj službenog telefona",
    },
    { 
      type: "input", 
      required: false, 
      placeholder: "Službena e-mail adresa",
    },
    ],
    suffix: " (u daljnjem tekstu: Osoba zadužena od voditelja obrade),"
  }
  ],
    
  headline: "daje sljedeću",
  title: "IZJAVU O POVJERLJIVOSTI",

  noArticleNumbers: true,

  articles: [
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            { type: "text", content: "kojom ja, gore navedeni, kao osoba koja u ime Voditelja obrade" },
            { type: "input", content: "", required: true, placeholder: "Poslovni subjekt" },
            { type: "text", content: "," },
            { type: "input", content: "", required: true, placeholder: "Ulica i kućni broj" },
            { type: "text", content: "," },
            { type: "input", content: "", required: true, placeholder: "Mjesto" },
            { type: "text", content: "," },
            { type: 'text', content: 'OIB:' },
            { type: "input",  required: true,},
            { type: "text", content: ", obavlja poslove obrade osobnih podataka, izjavljujem da ću sukladno odredbama Opće uredbe o zaštiti podataka pri obradi osobnih podataka:" }
          ],
        },
            
            {type: "text",
              mandatory: true,
              content: "\r\n-iste obrađivati na način kojim se osigurava odgovarajuća sigurnost osobnih podataka, uključujući zaštitu od neovlaštene ili nezakonite obrade te od slučajnog gubitka, uništenja ili oštećenja primjenom odgovarajućih tehničkih ili organizacijskih mjera,"},
            {
              type: "text",
              mandatory: true,
              content: "\r\n-postupati povjerljivo s osobnim podacima koji će mi tijekom rada za voditelja obrade biti dostupni te da neću iznositi iste u javnosti, niti ih na drugi način učiniti dostupnim trećim osobama, osim ako je to određeno zakonom. ",
            },
          ]
        },
  {
    title: "",
    mandatory: false,
    dummy: true,
    statements: [
      {
        type: "text",
        mandatory: true,
        editable: true,
        content: "Ovu izjavu o povjerljivosti sam u potpunosti pročitao i ona predstavlja moju pravnu volju te istu u znak suglasnosti potpisujem.	"},
      ]
  },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
  {
    mandatory: true,
    static: true,
    type: 3,  // signatures   
    statements: [],
  },

],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/90_izjava_povj_voditelj.ts